import React, { Component, useState, useEffect} from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import LinearProgress from "@material-ui/core/LinearProgress";
import { RadioGroup, FormControlLabel, Radio, FormControl, FormLabel, FormGroup } from "@material-ui/core";
import {fetchPolls,splitSession} from "../firebaseApi.js"

const styles = (theme) => ({});

function InstructorSessionSplit(props) {
  let mobile = props.width === "sm" || props.width === "xs";
  const [loading, setLoading] = React.useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [pollInfo, setInfo] = useState([]);
  const [polls, setPolls] = useState("");
  const [pollLength,setlength] = useState("");

    useEffect(()=>{
        fetchPolls({sessionID:props.sessionID}).then((data)=>{
            setPolls(data);
            Object.keys(data).forEach((pollID) => {
                setInfo((prevInfo) => [...prevInfo,pollID]);
            });
            setlength(pollInfo.length);
        })

    },[])
  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  function split() {
    setLoading(true);
    let data = {sessionID:props.sessionID,splitID:selectedOption,pollData:pollInfo}
    splitSession(data);
    setLoading(false);
    props.openCtl(false)
  }

  return (
    <Dialog
      fullScreen={mobile}
      fullWidth
      maxWidth="sm"
      open={props.open}
      onClose={() => {
        props.openCtl(false);
      }}
    >
      <DialogTitle>{"Split Session " + props.sessionNumber}</DialogTitle>

      <DialogContent>
        <FormControl component="fieldset">
            <FormLabel component="legend">Select the poll you want to split this session at:</FormLabel>
            <RadioGroup value={selectedOption} onChange={handleChange}>
            <FormGroup>
                    {Object.entries(polls).map(([pollID,poll])=>(
                        <FormControlLabel
                        key = {pollID}
                        value={pollID}
                        control={<Radio />}
                        label={"Poll " + poll.pollIndex}
                      />
                    ))}

                </FormGroup>
                
            </RadioGroup>
        </FormControl>
        <DialogContentText>
          Splitting this session will make this session into 2 sessions. One group of polls up until the selected poll (in chronological order), and another of the rest of the polls. 
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="primary"
          onClick={() => {
            props.openCtl(false);
          }}
        >
          Cancel
        </Button>

        <Button color="primary" disabled = {!selectedOption}onClick={split}>
          Split
        </Button>
      </DialogActions>
      {loading ? <LinearProgress /> : null}
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(withWidth()(InstructorSessionSplit))));
